import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=234b6560&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=234b6560&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b6560",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234b6560')) {
      api.createRecord('234b6560', component.options)
    } else {
      api.reload('234b6560', component.options)
    }
    module.hot.accept("./certificate.vue?vue&type=template&id=234b6560&scoped=true", function () {
      api.rerender('234b6560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffManage/staffForm/certificate.vue"
export default component.exports